import { render, staticRenderFns } from "./maison-construite.vue?vue&type=template&id=2c5fee85"
import script from "./maison-construite.vue?vue&type=script&lang=js"
export * from "./maison-construite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports